var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserListDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7145 8C6.27968 8 6.83217 7.8324 7.3021 7.51839C7.77202 7.20438 8.13827 6.75807 8.35454 6.2359C8.5708 5.71373 8.62736 5.13916 8.51706 4.58484C8.40676 4.03053 8.13456 3.52137 7.73488 3.12176C7.3352 2.72215 6.826 2.45004 6.27167 2.33984C5.71733 2.22964 5.14277 2.2863 4.62064 2.50265C4.09851 2.71901 3.65226 3.08534 3.33833 3.55532C3.02441 4.0253 2.8569 4.57782 2.857 5.143C2.8578 5.90056 3.15912 6.62687 3.69485 7.1625C4.23058 7.69813 4.95694 7.99934 5.7145 8Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4525 10.3605C8.72841 9.61779 7.79936 9.10779 6.78402 8.89564C5.76869 8.68349 4.71316 8.77882 3.75226 9.16946C2.79136 9.5601 1.96873 10.2283 1.38943 11.0887C0.81013 11.9492 0.500469 12.9627 0.5 14C0.5 14.1326 0.552678 14.2598 0.646447 14.3536C0.740215 14.4473 0.867392 14.5 1 14.5H10.43C10.5626 14.5 10.6898 14.4473 10.7836 14.3536C10.8773 14.2598 10.93 14.1326 10.93 14C10.9319 13.4698 10.8501 12.9426 10.6875 12.438C10.4454 11.6578 10.0222 10.9459 9.4525 10.3605Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.25C12.9236 8.25 13.875 7.2986 13.875 6.125C13.875 4.95139 12.9236 4 11.75 4C10.5764 4 9.625 4.95139 9.625 6.125C9.625 7.2986 10.5764 8.25 11.75 8.25Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.835C11.0798 8.83752 10.4225 9.02004 9.847 9.3635C9.9555 9.4605 10.065 9.556 10.1675 9.661C10.8483 10.3608 11.3541 11.2116 11.6435 12.144C11.7426 12.451 11.8157 12.7658 11.862 13.085H15C15.1326 13.085 15.2598 13.0323 15.3536 12.9386C15.4473 12.8448 15.5 12.7176 15.5 12.585C15.4989 11.5908 15.1035 10.6375 14.4005 9.93452C13.6974 9.23149 12.7442 8.83606 11.75 8.835Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserListDisabled);
export default __webpack_public_path__ + "static/media/ic-user-list-disabled.b162c8d2e885f097305767e6ed9e4dae.svg";
export { ForwardRef as ReactComponent };